
import React, { useEffect, useRef } from 'react';
import { Form2 } from '../../../../Common/Class/Form2';
import { useSelector } from 'react-redux';

export const InvoiceCategoryForm = ({updateInsight,prefill,forms,details,dependentField}) => {
    const FORM = useRef()
   const {tenant} = useSelector(state=>state.auth.config)
   const {entityWiseFilter} = useSelector(state=>state.auth.config.plugins)

    useEffect(() => {
        FORM.current && FORM.current.customForm(forms)
    },[forms,prefill,dependentField])

    let dependentKeyValue = {
        ...(tenant === "BSETEST" || tenant === "BSE") && (details.vendor && (details.vendor.msme || details.vendor.msmeId)) ?
            { "MSME_VENDOR": "Yes" } : {},
        ...(details && ((details.tags && details.tags.po_created_at)||(details.po && details.po.length))) ? { "po_id": "yes" } : { "po_id": "no" },
       ...dependentField
    }
    
    let masterKeyValue = {}
    // masterKeyValue.bill_to = "Multi Client Facility Bangalore"
    if(details.entity  && ['TESTASK','ASK'].includes(tenant) && entityWiseFilter) {
      const entityName =(details.entity && details.entity.name) ||''
      const match = entityName.match(/\(([^)]+)\)/);
      masterKeyValue.entity = match ? match[1] : entityName;
    }

    
    return (
        <Form2
            handler={ref => FORM.current = ref}
            extra={details.entityId ? { entityId: details.entityId } : {}}
            initialValues={prefill}
            masterKeyValue={masterKeyValue}
            dependentKeyValue={dependentKeyValue}
            updateForm={(key, value, multi=false) => updateInsight(key, value, multi)}
        />
    )
}